import React from 'react'
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import DomicilioEntrega from '../../components/DomicilioEntrega'
import {
    geocodeByAddress,
  } from 'react-places-autocomplete';
  import * as Notification from '../../components/Common/notification';
  import * as usuarioActions from '../../reducers/usuarioReducer/actions'
  //import * as sessionActions from '../../reducers/SessionReducer/actions'

class DomicilioEntregaContainer extends React.Component {

    constructor(props) {
        super(props)

        let existeSeleccion = this.props.esGeorreferenciacion === true && this.props.domicilioGeorreferenciacion && 
        this.props.domicilioGeorreferenciacion.latitud && this.props.domicilioGeorreferenciacion.longitud ? true : false

        this.state = {
            tipoUbicacionElegida: undefined,
            position: {
                lat: this.props.esGeorreferenciacion === true && this.props.domicilioGeorreferenciacion && this.props.domicilioGeorreferenciacion.latitud ? this.props.domicilioGeorreferenciacion.latitud : -31.638377,
                lng: this.props.esGeorreferenciacion === true && this.props.domicilioGeorreferenciacion && this.props.domicilioGeorreferenciacion.longitud ? this.props.domicilioGeorreferenciacion.longitud : -60.7041932
            },
            formUbicacion:{
                domicilio: this.props.esGeorreferenciacion === true && this.props.domicilioGeorreferenciacion && this.props.domicilioGeorreferenciacion.domicilio ? this.props.domicilioGeorreferenciacion.domicilio : undefined,
                pisoDepto: this.props.esGeorreferenciacion === true && this.props.domicilioGeorreferenciacion && this.props.domicilioGeorreferenciacion.pisoDepto ? this.props.domicilioGeorreferenciacion.pisoDepto : undefined,
                cp: this.props.esGeorreferenciacion === true && this.props.domicilioGeorreferenciacion && this.props.domicilioGeorreferenciacion.cp ? this.props.domicilioGeorreferenciacion.cp : undefined,
                localidad: this.props.esGeorreferenciacion === true && this.props.domicilioGeorreferenciacion && this.props.domicilioGeorreferenciacion.localidad ? this.props.domicilioGeorreferenciacion.localidad : undefined,
                opcional: this.props.esGeorreferenciacion === true && this.props.domicilioGeorreferenciacion && this.props.domicilioGeorreferenciacion.opcional ? this.props.domicilioGeorreferenciacion.opcional : undefined,
            },
            errores: {},
            existeSeleccion: existeSeleccion,
            zoom: existeSeleccion ? 16 : 13,
            ultimoDomicilioBuscado: existeSeleccion ? 
                                    {
                                        position: {
                                            lat: this.props.domicilioGeorreferenciacion.latitud,
                                            lng: this.props.domicilioGeorreferenciacion.longitud,
                                        },
                                        domicilio: this.props.domicilioGeorreferenciacion.domicilio
                                    } : undefined,
            openModalBorrarDireccion: false,
            idDomicilioEntrega: undefined,

            country: this.props.esGeorreferenciacion === true && this.props.domicilioGeorreferenciacion && this.props.domicilioGeorreferenciacion.country ? this.props.domicilioGeorreferenciacion.country : undefined,
            administrativeAreaLevel1: this.props.esGeorreferenciacion === true && this.props.domicilioGeorreferenciacion && this.props.domicilioGeorreferenciacion.administrativeAreaLevel1 ? this.props.domicilioGeorreferenciacion.administrativeAreaLevel1 : undefined,
            administrativeAreaLevel2: this.props.esGeorreferenciacion === true && this.props.domicilioGeorreferenciacion && this.props.domicilioGeorreferenciacion.administrativeAreaLevel2 ? this.props.domicilioGeorreferenciacion.administrativeAreaLevel2 : undefined,
            locality: this.props.esGeorreferenciacion === true && this.props.domicilioGeorreferenciacion && this.props.domicilioGeorreferenciacion.locality ? this.props.domicilioGeorreferenciacion.locality : undefined,
        }
    }

    /*
    setError(error) {
        if(error) {
            this.setState({
                formUbicacion:{
                    domicilio: this.state.formUbicacion.domicilio,
                    pisoDepto: undefined,
                    cp: undefined,
                    localidad: undefined,
                    opcional: undefined,
                },
                error: error
            })    
        }                         
    }
    */

    handleOnClickUbicacion = (value, limpiar, geocoder) => {
        
        if(limpiar === true){
            this.setState({
                tipoUbicacionElegida: undefined,
                position: {
                    lat: -31.638377,
                    lng: -60.7041932
                },
                formUbicacion:{
                    domicilio: undefined,
                    pisoDepto: undefined,
                    cp: undefined,
                    localidad: undefined,
                    opcional: undefined,
                },
                errores: {},
                zoom: 13,
                existeSeleccion: false,
                ultimoDomicilioBuscado: undefined
            })
        }
        else{
            this.setState({tipoUbicacionElegida: value}, () => {    
                if(value === 1){
                  this.geolocate(geocoder)
                }
            })
        }
        
    }

    geolocate = (geocoder) => {
        
        let self = this
        if(navigator.geolocation){
            var success = function(position){
                let latitud = position.coords.latitude
                let longitud = position.coords.longitude

                let pos = {
                    lat: latitud,
                    lng: longitud
                }
                
                let postalCode = undefined
                let localidad = undefined
                let domicilio = undefined

                let country = undefined
                let administrativeAreaLevel1 = undefined
                let administrativeAreaLevel2 = undefined
                let locality = undefined

                if(geocoder){
                    geocoder.geocode({ location: pos}, (results, status) => {
                        if (status === "OK") {                        
                            if(results[0] && results[0].address_components && results[0].address_components.length > 0){
    
                                domicilio = results[0].formatted_address
    
                                results[0].address_components.forEach(item => {
                                    if(item.types.find(x => x === "postal_code") !== undefined){
                                        postalCode = item.long_name.substring(1, 5)
                                    }
                                    if(item.types.find(x => x === "locality") !== undefined && item.types.find( x => x === "political") !== undefined ){
                                        locality = item.long_name
                                    }
                                    if(item.types.find(x => x === "administrative_area_level_2") !== undefined && item.types.find( x => x === "political") !== undefined ){
                                        administrativeAreaLevel2 = item.long_name
                                        localidad = item.long_name
                                    }
                                    if(item.types.find(x => x === "administrative_area_level_1") !== undefined && item.types.find( x => x === "political") !== undefined ){
                                        localidad = localidad && localidad.length > 0 ? localidad + ", " + item.long_name : item.long_name
                                        administrativeAreaLevel1 = item.long_name
                                    }
                                    /*if(item.types.find(x => x === "administrative_area_level_2") !== undefined && item.types.find( x => x === "political") !== undefined ){
                                        administrativeAreaLevel2 = item.long_name
                                    }*/
                                    if(item.types.find(x => x === "country") !== undefined && item.types.find( x => x === "political") !== undefined ){
                                        country = item.long_name
                                    }
                                });
    
                                let form = self.state.formUbicacion
                                form.cp = postalCode
                                form.localidad = localidad
                                form.domicilio = domicilio

                                let ultimoDomicilioBuscado = {
                                    domicilio: domicilio,
                                    position: pos
                                }
    
                                self.setState({
                                    form: form,
                                    ultimoDomicilioBuscado: ultimoDomicilioBuscado,
                                    country: country,
                                    administrativeAreaLevel1: administrativeAreaLevel1,
                                    administrativeAreaLevel2: administrativeAreaLevel2,
                                    locality: locality
                                })
                            } else {
                                Notification.showInfo('No se encontró su ubicación')
                            }
                        } else {
                            Notification.showInfo('No se encontró su ubicación')
                        }
                    });
                }
                

                self.setState({
                    position: pos,
                    zoom: 16,
                    existeSeleccion: true
                })
            }

            navigator.geolocation.getCurrentPosition(
                success, 
                function(msg){
                    self.setState({tipoUbicacionElegida: undefined}, () => {
                        Notification.showInfo('Debe dar permisos a la aplicación para poder encontrar su ubicación.')
                    });
            }, {maximumAge:0, timeout:5000, enableHighAccuracy: true});
        }
    }

    handleSelect = (selected) => {
        
        let postalCode = undefined
        let localidad = undefined
        let errores = {}

        geocodeByAddress(selected)
            .then(res => {

                let country = undefined
                let administrativeAreaLevel1 = undefined
                let administrativeAreaLevel2 = undefined
                let locality = undefined
                
                if(res[0] && res[0].address_components && res[0].address_components.length > 0){
                    res[0].address_components.forEach(item => {
                        if(item.types.find(x => x === "postal_code") !== undefined){
                            postalCode = item.long_name.substring(1, 5)
                        }
                        if(item.types.find(x => x === "locality") !== undefined && item.types.find( x => x === "political") !== undefined ){
                            //localidad = item.long_name
                            locality = item.long_name
                        }
                        if(item.types.find(x => x === "administrative_area_level_2") !== undefined && item.types.find( x => x === "political") !== undefined ){
                            administrativeAreaLevel2 = item.long_name
                            localidad = item.long_name
                        }
                        if(item.types.find(x => x === "administrative_area_level_1") !== undefined && item.types.find( x => x === "political") !== undefined ){
                            localidad = localidad && localidad.length > 0 ? localidad + ", " + item.long_name : item.long_name
                            administrativeAreaLevel1 = item.long_name
                        }
                        /*if(item.types.find(x => x === "administrative_area_level_2") !== undefined && item.types.find( x => x === "political") !== undefined ){
                            administrativeAreaLevel2 = item.long_name
                        }*/
                        if(item.types.find(x => x === "country") !== undefined && item.types.find( x => x === "political") !== undefined ){
                            country = item.long_name
                        }
                    });
                };

                let position = {...this.state.position}

                if(res[0] && res[0].geometry && res[0].geometry.location){
                    position.lat = res[0].geometry.location.lat()
                    position.lng = res[0].geometry.location.lng()
                }

                let form = this.state.formUbicacion
                form.cp = postalCode
                form.localidad = localidad
                form.domicilio = selected
                
                let ultimoDomicilioBuscado = {
                    domicilio: selected,
                    position: position
                }

                this.setState({
                    form: form,
                    position: position,
                    zoom: 16,
                    existeSeleccion: true,
                    ultimoDomicilioBuscado: ultimoDomicilioBuscado,
                    country: country,
                    administrativeAreaLevel1: administrativeAreaLevel1,
                    administrativeAreaLevel2: administrativeAreaLevel2,
                    locality: locality
                });
            })
            .catch(error => {
                console.log('error', error); // eslint-disable-line no-console
            });
    }

    handleChangeAutocomplete = address => {

        let form = this.state.formUbicacion
        form.domicilio = address
        this.setState({ formUbicacion: form });
    };

    handleChangeForm = (e) => {
        let value = e.target.value
        let name = e.target.name

        let form = this.state.formUbicacion
        form[name] = value

        this.setState({ formUbicacion: form });
    };

    handleOnClickSave = () => {
        let valida = true;
        let errores = {};


        if(this.state.formUbicacion.domicilio === undefined || this.state.formUbicacion.domicilio === null || this.state.formUbicacion.domicilio === ''){
            errores.domicilio = 'Domicilio no puede ser vacío y debe ser valido'
            valida = false
        }

        /*if(this.state.formUbicacion.cp === undefined || this.state.formUbicacion.cp === null || this.state.formUbicacion.cp === ''){
            errores.cp = 'Seleccione una localidad'
            valida = false
        }*/

        if(this.state.formUbicacion.localidad === undefined || this.state.formUbicacion.localidad === null || this.state.formUbicacion.localidad === ''){
            errores.localidad = 'Domicilio no puede ser vacío y debe ser valido'
            valida = false
        }

        if(this.state.ultimoDomicilioBuscado === undefined){
            errores.domicilio = 'Realice una búsqueda por domicilio'
            valida = false
        }

        if(this.state.ultimoDomicilioBuscado !== undefined && this.state.formUbicacion.domicilio !== undefined &&this.state.ultimoDomicilioBuscado.domicilio !== this.state.formUbicacion.domicilio){
            errores.domicilio = 'El domicilio no coincide con la búsqueda realizada. Seleccione nuevamente.'
            valida = false
        }

        if(this.state.ultimoDomicilioBuscado !== undefined && this.state.ultimoDomicilioBuscado.position && this.state.position &&
            (this.state.ultimoDomicilioBuscado.position.lat !== this.state.position.lat || this.state.ultimoDomicilioBuscado.position.lng !== this.state.position.lng)){
            errores.domicilio = 'El domicilio no coincide con la búsqueda realizada. Seleccione nuevamente.'
            valida = false
        }

        if(!valida){
            this.setState({errores: errores})
            return
        }
        else{
            if(this.state.existeSeleccion === false){
                errores.domicilio = 'Realice una búsqueda por domicilio'
                valida = false

                this.setState({errores: errores})
                return
            }
        }

        this.setState({errores:{}}, () => {
            let payload = {
                domicilio: this.state.formUbicacion.domicilio ? this.state.formUbicacion.domicilio.trim() : undefined,
                pisoDepto: this.state.formUbicacion.pisoDepto ? this.state.formUbicacion.pisoDepto.trim() : undefined,
                cp: this.state.formUbicacion.cp ? this.state.formUbicacion.cp : undefined,
                opcional: this.state.formUbicacion.opcional ? this.state.formUbicacion.opcional.trim() : undefined,
                idUsuario: this.props.usuario.id,
                idInstalacion: this.props.instalacion.id,
                latitud: this.state.ultimoDomicilioBuscado.position.lat,
                longitud: this.state.ultimoDomicilioBuscado.position.lng,
                country: this.state.country,
                administrativeAreaLevel1: this.state.administrativeAreaLevel1,
                administrativeAreaLevel2: this.state.administrativeAreaLevel2,
                locality: this.state.locality,
            }
            
            if(this.props.esGeorreferenciacion){
                this.props.handleOnSaveGeorreferenciacion(payload)
            }
            else{
                payload.callback = (domicilio) => {
                    this.props.handleAfterSaveNuevoDomicilio(domicilio.idDomicilioEntrega)
                    Notification.showSuccess(`Domicilio guardado con éxito`)
                }
        
                payload.callbackError = (error) => {
                    Notification.showError('Error al guardar domicilio: ' + error)
                }
        
                this.props.sagaSaveDireccionEntrega(payload)
            }
        })
    }

    handleOnClickDeleteDireccion = (idDireccion, confirma, cancela) => {

        if(cancela === true){
            //limpio datos del estado, cierro modal
            this.setState({openModalBorrarDireccion: false, idDomicilioEntrega: undefined})
            return
        }

        if(confirma === true){

            let payload = {}
            payload.idDomicilioEntrega = this.state.idDomicilioEntrega
            
            payload.callback = (domicilio) => {
                //limpio datos del estado, cierro modal
                this.setState({openModalBorrarDireccion: false, idDomicilioEntrega: undefined}, () => {
                    Notification.showSuccess(`Domicilio eliminado con éxito`)
                })
            }
    
            payload.callbackError = (error) => {
                Notification.showError('Error al eliminar domicilio: ' + error)
            }
            //llamar a la saga
            //this.props.sagaEliminarDireccion(payload)
            
            
        }
        else{
            //abro modal
            this.setState({openModalBorrarDireccion: true, idDomicilioEntrega: idDireccion})
        }
    }

    moveMarker = (geocoder, position) => {
        
        let self = this
        let errores = {}

        let postalCode = undefined
        let localidad = undefined
        let domicilio = undefined

        let country = undefined
        let administrativeAreaLevel1 = undefined
        let administrativeAreaLevel2 = undefined
        let locality = undefined

        if(geocoder){
            geocoder.geocode({ location: position}, (results, status) => {
                if (status === "OK") {                        
                    if(results[0] && results[0].address_components && results[0].address_components.length > 0){

                        domicilio = results[0].formatted_address

                        results[0].address_components.forEach(item => {
                            if(item.types.find(x => x === "postal_code") !== undefined){
                                postalCode = item.long_name.substring(1, 5)
                            }
                            if(item.types.find(x => x === "locality") !== undefined && item.types.find( x => x === "political") !== undefined ){
                                //localidad = item.long_name
                                locality = item.long_name
                            }
                            if(item.types.find(x => x === "administrative_area_level_2") !== undefined && item.types.find( x => x === "political") !== undefined ){
                                administrativeAreaLevel2 = item.long_name
                                localidad = item.long_name
                            }
                            if(item.types.find(x => x === "administrative_area_level_1") !== undefined && item.types.find( x => x === "political") !== undefined ){
                                localidad = localidad && localidad.length > 0 ? localidad + ", " + item.long_name : item.long_name
                                administrativeAreaLevel1 = item.long_name
                            }
                            /*if(item.types.find(x => x === "administrative_area_level_2") !== undefined && item.types.find( x => x === "political") !== undefined ){
                                administrativeAreaLevel2 = item.long_name
                            }*/
                            if(item.types.find(x => x === "country") !== undefined && item.types.find( x => x === "political") !== undefined ){
                                country = item.long_name
                            }
                        });

                        let form = self.state.formUbicacion
                        form.cp = postalCode
                        form.localidad = localidad
                        form.domicilio = domicilio

                        let ultimoDomicilioBuscado = {
                            domicilio: domicilio,
                            position: position
                        }

                        self.setState({
                            form: form,
                            ultimoDomicilioBuscado: ultimoDomicilioBuscado,
                            position: position,
                            zoom: 16,
                            existeSeleccion: true,
                            country: country,
                            administrativeAreaLevel1: administrativeAreaLevel1,
                            administrativeAreaLevel2: administrativeAreaLevel2,
                            locality: locality
                        })
                    } else {
                        Notification.showInfo('No se encontró su ubicación')
                    }
                } else {
                    Notification.showInfo('No se encontró su ubicación')
                }
            });
        }
    }

    render() {

        return (
            <DomicilioEntrega
                domicilios={this.props.domicilios}
                domicilioSeleccionado={this.props.domicilioSeleccionado}
                esGeorreferenciacion={this.props.esGeorreferenciacion}
                tipoUbicacionElegida={this.state.tipoUbicacionElegida}
                position={this.state.position}
                formUbicacion={this.state.formUbicacion}
                errores={this.state.errores}
                zoom={this.state.zoom}
                existeSeleccion={this.state.existeSeleccion}
                openModalBorrarDireccion={this.state.openModalBorrarDireccion}
                handleOnClickUbicacion={this.handleOnClickUbicacion}
                handleSelect={this.handleSelect}
                handleChangeAutocomplete={this.handleChangeAutocomplete}
                handleChangeForm={this.handleChangeForm}
                handleChangeRadioButton={this.props.handleChangeRadioButtonDomicilio}
                handleOnClickSave={this.handleOnClickSave}
                handleOnClickDeleteDireccion={this.handleOnClickDeleteDireccion}
                moveMarker={this.moveMarker}
                handleOnClickGeorreferenciar={this.props.handleOnClickGeorreferenciar}
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        ...usuarioActions
    }, dispatch)
}

function mapStateToProps(state) {
    return {
    }
}

DomicilioEntregaContainer.propTypes = {
    domicilioSeleccionado: PropTypes.string.isRequired,
    domicilios: PropTypes.array.isRequired,
    handleChangeRadioButtonDomicilio: PropTypes.func.isRequired,
    handleAfterSaveNuevoDomicilio: PropTypes.func.isRequired,
    handleOnSaveGeorreferenciacion: PropTypes.func.isRequired,
    instalacion: PropTypes.object.isRequired,
    usuario: PropTypes.object.isRequired,
    esGeorreferenciacion: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(DomicilioEntregaContainer)